import {
  LOGIN_SUCCESS,
  LOGOUT,
  LOGIN_FAILURE,
  SET_USER
} from "../constants/AuthConstants";

const isLogin = !!sessionStorage.getItem("token");
const initialState = isLogin
  ? {
      loggedIn: true,
      err: ""
    }
  : { loggedIn: false, err: "" };

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        err: ""
      };

    case LOGOUT:
      return {
        loggedIn: false,
        loginFailed: false,
        err: ""
      };

    case LOGIN_FAILURE:
      return {
        loggedIn: false,
        loginFailed: true,
        err: action.error
      };

    default:
      return state;
  }
}
